// Build & download a single-event .ics calendar file (floating local time).
const pad = (n) => String(n).padStart(2, "0");
const fmtLocal = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
const esc = (s) => (s || "").replace(/([,;\\])/g, "\\$1").replace(/\n/g, "\\n");

export function buildIcs({ uid, title, start, end, location = "", url = "", alarmMin = 30 }) {
  const e = end || new Date(start.getTime() + 30 * 60000);
  const stamp = new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
  return [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//jeeo//EN", "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${uid}@routerev`,
    `DTSTAMP:${stamp}`,
    `DTSTART:${fmtLocal(start)}`,
    `DTEND:${fmtLocal(e)}`,
    `SUMMARY:${esc(title)}`,
    `LOCATION:${esc(location)}`,
    url ? `URL:${esc(url)}` : null,
    "BEGIN:VALARM", `TRIGGER:-PT${alarmMin}M`, "ACTION:DISPLAY",
    `DESCRIPTION:${esc("Leave soon for " + title)}`,
    "END:VALARM",
    "END:VEVENT", "END:VCALENDAR",
  ].filter(Boolean).join("\r\n");
}

export function downloadIcs(opts) {
  const blob = new Blob([buildIcs(opts)], { type: "text/calendar;charset=utf-8" });
  const u = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = u;
  a.download = `${(opts.title || "event").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 2000);
}
